import React from "react";

interface Props {}

export const PageComponent: React.FunctionComponent<Props> = (props) => {
    return <>Error 404</>;
};
